import React, {FC, useState} from 'react';
import styles from './Sidedrawer.module.scss';
import {Drawer, IconButton, List, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import {Link} from "react-router-dom";
import {NavigationItem} from "../../../models/NavigationItem";
import logo from "../../../assets/images/nps-logo.png";
import Menu from "../../app/Navigation/menu/menu";

interface SidedrawerProps {}

const Sidedrawer: FC<SidedrawerProps> = () => {
    const [openDrawer, setOpenDrawer] = useState(false);

    const generalInfoItems: NavigationItem[] = [
        {title: 'Overview', url: './overview'},
        {title: 'Security Guidelines', url: './securityguidelines'},
        {title: 'Working with TIC', url: './workingwithtic'}];

    const resourceItems: NavigationItem[] = [
        {title: 'Park Index', url: './parkindex'}];

    const helpItems: NavigationItem[] = [
        {title: 'Help Page', url: './HelpPage'},
        {title: 'FAQs', url: './Faqs'},
        {title: 'Accessibility', url: './Accessibility'},
    ];

    const aboutItems: NavigationItem[] = [
        {title: 'Archiving With TIC', url: './archiving'},
        {title: 'Mission Statement', url: './missionstatement'}];

    const fileUpload: NavigationItem[] = [
        {title: 'File Upload', url: './fileupload'}];


    const contactItems: NavigationItem[] = [
        {title: 'Contact Us', url: './teams'},
        {title: 'Microsoft Teams', url: './chat'}];
    return(
        <>
            <Drawer
                anchor="left"
                open={openDrawer}
                onClose={() => setOpenDrawer(false)}
                sx={{
                    '& .MuiDrawer-root': {
                        backgroundColor: 'black'
                    },
                    '& .MuiPaper-root': {
                        backgroundColor: 'black'
                    },
                }}
            >
                <div className={styles.drawercontainer}>
                    <img src={logo} alt="National Park Service logo" className={styles.logoside}></img>
                    <br></br>
                    <button><Link to={"/"}> <span className="search">Search</span></Link></button>

                    <Menu title={"TIC General Information "} menuItems={generalInfoItems}></Menu>
                    <Menu title={"Resources"} menuItems={resourceItems}></Menu>
                    <Menu title={"File Upload"} menuItems={fileUpload}></Menu>
                    <Menu title={"Help | FAQ"} menuItems={aboutItems}></Menu>
                    <Menu title={"About"} menuItems={aboutItems}></Menu>
                    <Menu title={"Contact"} menuItems={contactItems}></Menu>
                </div>
            </Drawer>
            
            <IconButton
                sx={{ color: "white", marginRight:"auto", paddingLeft:2}}
                onClick={() => setOpenDrawer(!openDrawer)}
            >
                <MenuIcon />
            </IconButton>
        </>
    )
}


export default Sidedrawer;
